module.exports = __webpack_public_path__ + "static/media/logo_celeste.67cb193d.png";